import React, { useContext } from "react";
import LangContext from "../../../langContext";
import Pie from "lib/components/charts/pie.jsx";
import * as CONSTANTS from "../../../constants";

const PieChart = (props) => {
  const languageContext = useContext(LangContext);
  const progressValue = props.progress || 0;

  return (
    <Pie
      style={{ height: 110, width: 110 }}
      titleConfig={{ color: CONSTANTS.COLOR_2, titleFontSize: "22px", y: 25 }}
      value={`${progressValue}%`}
      data={[
        {
          name: languageContext("finished2"),
          color: CONSTANTS.COLOR_2,
          y: progressValue,
        },
        {
          name: languageContext("remaining"),
          color: CONSTANTS.COLOR_3,
          y: 100 - progressValue,
        },
      ]}
      legendConfig={{ enabled: false }}
      margin="0"
    />
  );
};

export default PieChart;
